import React, { FC } from "react";
import classNames from "classnames";
import ReactPlayer from "react-player";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { TabSlide as ITabSlide } from "@app/components/base-page/models";
import { BlockHeader } from "@app/components/common/block-header/BlockHeader";
import { checkFileType, FileType } from "@app/helpers/check-file-type";

type Props = {
  data: ITabSlide;
};

export const Slide: FC<Props> = ({ data }) => {
  return (
    <div className="relative w-full">
      <div className={classNames("w-full")}>
        {checkFileType(data.media.filename) === FileType.VIDEO ? (
          <ReactPlayer
            className={classNames(
              "[&>video]:aspect-[1.28] [&>video]:rounded-lg [&>video]:object-cover",
              "lg:[&>video]:aspect-video",
            )}
            url={data.media.filename}
            width="100%"
            height="auto"
            playing
            muted
            loop
            playsinline
            config={{
              file: {
                attributes: { disablePictureInPicture: true },
              },
            }}
          />
        ) : (
          <GatsbyImage
            image={getGatsbyImage(data.media.filename, {
              layout: "fullWidth",
            })}
            alt={data.media.alt}
            className={classNames(
              "aspect-[1.28] w-full rounded-lg",
              "lg:aspect-video",
            )}
            loading="eager"
          />
        )}
      </div>
      <div
        className={classNames(
          "mt-6",
          "lg:absolute lg:inset-0 lg:z-10 lg:mx-14 lg:mt-0 lg:flex lg:flex-col lg:justify-around",
          "xl:mx-18 xl:justify-center",
        )}
      >
        <div className="lg:flex-1 xl:flex-none"></div>
        <div
          className={classNames(
            "text-left lg:w-2/3 lg:flex-1",
            "xl:w-3/4 xl:flex-initial",
            "xxl:w-1/2",
          )}
        >
          <BlockHeader
            className={classNames(
              "mb-6 text-medium text-primary-content",
              "lg:mb-4 lg:text-large",
              "xl:text-xx-large",
            )}
            richText={data.title}
          />
          <div
            className={classNames(
              "text-regular text-base-400",
              "lg:text-primary-content",
              "xl:text-medium",
            )}
          >
            <BlockBody richText={data.text} />
          </div>
        </div>
      </div>
    </div>
  );
};
